// import { useEffect } from 'react';
// import { useAppDispatch, useAppSelector } from '../../../store/hooks';
// import { getPaymentTypeList } from '../../../store/Finance/AP/ApPayments/ApPaymentsSlice';

const useGetPaymentTypeList = () => {
  // const dispatch = useAppDispatch();
  // useEffect(() => {
  //   // if (PaymentTypeList?.length === 0) {
  //     dispatch(getPaymentTypeList());
  //   // }
  // }, []);
  // // const { PaymentTypeList, loading2, error } = useAppSelector(state => state.ApPayments);

  const PaymentTypeList = [
    { id: '52ea7dc3-92b7-406d-9f79-f12e0fb8fdb2', name: 'Standard', name2: 'قياسي' },
    { id: 'b600351c-8d3c-43df-83c4-9120a79c74aa', name: 'Refund', name2: 'استرداد' },
    { id: 'e232d787-c1d1-4d97-be39-ff52f9010683', name: 'PrePayment', name2: 'دفعة مقدمة' },
    { id: '45de9a40-acc4-4088-ab2f-3b07b98d3927', name: 'ApplyPrePayment', name2: 'تطبيق دفعة مقدمة' },
    { id: 'b2e01e84-98f9-4d51-9f7f-beec65353953', name: 'ApplyCreditMemo', name2: 'تطبيق اشعار مدين' },
    { id: '5c18c696-2ef8-43b7-97d9-ab5654f2c0b0', name: 'PrePaymentRefund', name2: 'استرداد دفعة مقدمة' },
    // { id: '0464fc34-11f9-490f-b469-7f5d4d7150f1', name: 'Quick', name2: 'سريع' },
  ];

  return { PaymentTypeList };
};

export default useGetPaymentTypeList;
 